var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgThumbsup = function SvgThumbsup(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 15 16"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipPath: "url(#thumbsup_svg__a)",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.5.54c.43 4.78-2.07 6.78-2.78 7.24v6.98l1.17.72h6.14a.1.1 0 0 1 .03 0c1.42.22 1.47-1.65 1.47-1.89 0-.11.05-.23.15-.28.89-.43.51-1.77.48-1.89a.3.3 0 0 1 .13-.35c1.14-.63.42-1.75.33-1.9a.3.3 0 0 1-.03-.34c2.08-3.59-4.42-2.7-4.83-2.64a.2.2 0 0 1-.1 0c-.14-.03-.23-.18-.2-.33C10.42.34 8.18.39 7.48.54Zm-3.2 14.3v-6.9a.65.65 0 0 0-.15-.43.5.5 0 0 0-.37-.17H.53a.5.5 0 0 0-.38.17.63.63 0 0 0-.15.42v6.91c0 .16.06.31.15.42.1.11.23.17.38.17h3.25c.15 0 .28-.06.37-.17.08-.09.14-.2.16-.33v-.09Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "thumbsup_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 .5h15v15H0z"
  })))));
};
export default SvgThumbsup;